import { render, staticRenderFns } from "./aRmsYearSalesTable.vue?vue&type=template&id=74236c2a&scoped=true"
import script from "./aRmsYearSalesTable.vue?vue&type=script&lang=js"
export * from "./aRmsYearSalesTable.vue?vue&type=script&lang=js"
import style0 from "./aRmsYearSalesTable.vue?vue&type=style&index=0&id=74236c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74236c2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VTooltip})
